module.exports = __webpack_public_path__ + "assets/img/1.256766eb.jpg";